import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { getAuth } from 'firebase/auth';
import { getBookmarkedArticles, removeBookmark } from '../services/firebase/bookmarks';
import '../styles/global.css';
import '../styles/bookmarks.css';

const BookmarksPage = () => {
  const [bookmarked, setBookmarked] = useState([]);
  const [loading, setLoading] = useState(true);
  const [user, setUser] = useState(null);

  const bgStyle = {
    backgroundColor: '#f9f7f2',
    minHeight: '100vh'
  };

  useEffect(() => {
    const auth = getAuth();
    setUser(auth.currentUser);
    
    const loadBookmarks = async () => {
      try {
        if (auth.currentUser) {
          const data = await getBookmarkedArticles();
          setBookmarked(data);
        }
      } catch (err) {
        console.error('Error loading bookmarks:', err);
      } finally {
        setLoading(false);
      }
    };
    loadBookmarks();
  }, []);

  const handleRemove = async (articleId) => {
    try {
      await removeBookmark(articleId);
      setBookmarked(prev => prev.filter(a => a.id !== articleId));
    } catch (err) {
      console.error('Error removing bookmark:', err);
    }
  };

  if (!user) {
    return (
      <div style={bgStyle}>
        <div className="container">
          <div className="login-required">
            <h2>Login Required</h2>
            <p>You need to be logged in to view your bookmarks.</p>
            <button
              onClick={() => {
                // This will trigger the auth modal in the Layout component
                window.location.href = '/';
                setTimeout(() => {
                  const event = new CustomEvent('open-auth-modal');
                  window.dispatchEvent(event);
                }, 100);
              }}
              className="login-button"
            >
              Login or Register
            </button>
          </div>
        </div>
      </div>
    );
  }

  if (loading) return (
    <div style={bgStyle}>
      <div className="container">
        <div className="loading-container">
          <div className="loading-spinner">Loading bookmarks...</div>
        </div>
      </div>
    </div>
  );

  return (
    <div style={bgStyle}>
      <div className="container">
        <main className="bookmarks-page">
          <h2 className="bookmarks-title">My Bookmarked Articles</h2>

          {bookmarked.length === 0 ? (
            <div className="no-bookmarks">
              <p>You haven't saved any articles yet.</p>
              <Link to="/" className="browse-articles-link">Browse Articles</Link>
            </div>
          ) : (
            <div className="bookmarks-list">
              {bookmarked.map(article => (
                <div key={article.id} className="bookmark-item">
                  <div className="bookmark-content">
                    <Link to={`/article/${article.id}`} className="bookmark-title">
                      {article.title}
                    </Link>
                    
                    <div className="bookmark-meta">
                      <Link to={`/author/${article.authorId || 'unknown'}`} className="bookmark-author-link">
                        <img 
                          src={article.authorImage || '/images/default-user.png'} 
                          alt={article.author} 
                          className="bookmark-author-image" 
                        />
                        <span className="bookmark-author-name">{article.author}</span>
                      </Link>
                      
                      <span className="bookmark-date">
                        {new Date(article.createdAt || Date.now()).toLocaleDateString('en-US', {
                          year: 'numeric',
                          month: 'short',
                          day: 'numeric'
                        })}
                      </span>
                    </div>
                  </div>
                  
                  <button
                    onClick={() => handleRemove(article.id)}
                    className="bookmark-remove-button"
                    aria-label="Remove bookmark"
                  >
                    <span className="remove-icon">✕</span>
                  </button>
                </div>
              ))}
            </div>
          )}
        </main>
      </div>
    </div>
  );
};

export default BookmarksPage;
